var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('SettingsSidebar'),_c('div',{class:_vm.$style.contentContainer},[_c('div',{class:_vm.$style.content},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }